const EMPTY_PAYLOAD = {
  id: '',
  handlersProjectDeliverableTypesRequest: {
    deliverableTypeIds: [],
  },
};

export { EMPTY_PAYLOAD };
